/**
 * @author caijianjia
 * @date 2020/3/25 5:22 下午
 */

import store from '../store'
import request from '../config/network/requestUcenterApiService'
import {apiUpdate} from './localdata'

/**
 * 资源管理
 */

// 新建资源
export function addResource ({
  clientsId,
  sort = 'scenes_stage',
  categoryId = 0,
  name,
  title,
  alias,
  attributes,
  is_online,
  ...params
}) {
  return request({
    url: `api/courseware/resources?clients_id=${clientsId}`,
    method: 'post',
    data: {
      clients_id: clientsId,
      sort,
      category_id: categoryId,
      name,
      title,
      alias,
      attributes,
      is_online,
      ...params
    }
  })
}

// 批量新建资源
export function addBatchResource ({
  clientsId,
  sort = 'scenes_stage',
  categoryId = 0,
  data
}) {
  return request({
    url: `api/courseware/resources-multi?clients_id=${clientsId}`,
    method: 'post',
    data: {
      clients_id: clientsId,
      sort,
      category_id: categoryId,
      data
    }
  })
}

// 删除资源
export function deleteResource ({ id, clientsId }) {
  return request({
    url: `api/courseware/resources/${id}`,
    method: 'delete',
    data: { clients_id: clientsId }
  })
}

// 修改资源
export function updateResource ({
  id,
  clientsId,
  sort = 'scenes_stage',
  categoryId = 0,
  name,
  title,
  cover,
  attributes,
  is_online,
  method,
  noLock,
  ...params
}) {
  let data={
    url: `api/courseware/resources/${id}?clients_id=${clientsId}`,
    method: method || 'put',
    noLock,
    data: {
      clients_id: clientsId,
      sort,
      category_id: categoryId,
      name,
      title,
      cover,
      attributes,
      is_online,
      ...params
    }
  };
  return apiUpdate(data,id);
}

// 获取资源列表
export function getResourceList ({
  id,
  search,
  clientsId,
  categoryId,
  sort,
  scenesStageId,
  page,
  perPage,
  is_online
}) {
  let url = 'api/courseware/resources'
  if (search) {
    url += `?like[name]=${search}`
  }
  let no_attributes=(sort==="template")?1:0;
  return request({
    url,
    method: 'get',
    params: {
      clients_id: clientsId,
      'equal[sort]': sort,
      'equal[category_id]': categoryId || 0,
      'equal[is_online]': is_online,
      'equal[id]': id,
      'equal[scenes_stage_id]': scenesStageId,
      no_attributes,
      page,
      per_page: perPage
    }
  })
}

// 获取资源详情
export function getResourceDetail ({
   id,
   clientsId,
   config_type
}) {
  return request({
    url: `api/courseware/resources/${id}`,
    method: 'get',
    params: {
      clients_id: clientsId,
      config_type
    }
  })
}

// 设置默认资源
export function setResourceDefault ({ id, clientsId, isDefault = 1 }) {
  return request({
    url: `api/courseware/resources/${id}/default`,
    method: 'patch',
    data: {
      clients_id: clientsId,
      is_default: isDefault
    }
  })
}

/**
 * 资源管理 - 商城
 */

// 新建资源
export function addResourceShop ({
  clientsId,
  sort = 'scenes_stage',
  categoryId = 0,
  name,
  title,
  alias,
  attributes,
  is_online,
  ...params
}) {
  return request({
    url: `api/courseware/shop-resources?clients_id=${clientsId}`,
    method: 'post',
    data: {
      clients_id: clientsId,
      sort,
      category_id: categoryId,
      name,
      title,
      alias,
      attributes,
      is_online,
      ...params
    }
  })
}

// 批量新建资源
export function addBatchResourceShop ({
  clientsId,
  sort = 'scenes_stage',
  categoryId = 0,
  data
}) {
  return request({
    url: `api/courseware/shop-resources-multi?clients_id=${clientsId}`,
    method: 'post',
    data: {
      clients_id: clientsId,
      sort,
      category_id: categoryId,
      data
    }
  })
}

// 删除资源
export function deleteResourceShop ({ id, clientsId }) {
  return request({
    url: `api/courseware/shop-resources/${id}`,
    method: 'delete',
    data: { clients_id: clientsId }
  })
}

// 修改资源
export function updateResourceShop ({
  id,
  clientsId,
  sort = 'scenes_stage',
  categoryId = 0,
  name,
  title,
  cover,
  attributes,
  is_online,
  method,
  noLock,
  ...params
}) {
  return apiUpdate({
    url: `api/courseware/shop-resources/${id}?clients_id=${clientsId}`,
    method: method || 'put',
    noLock,
    data: {
      clients_id: clientsId,
      sort,
      category_id: categoryId,
      name,
      title,
      cover,
      attributes,
      is_online,
      ...params
    }
  },id);
}

// 获取资源列表
export function getResourceShopList ({
  id,
  search,
  clientsId,
  categoryId,
  sort,
  scenesStageId,
  page,
  perPage,
  is_online
}) {
  let url = 'api/courseware/shop-resources?'
  if (search) {
    url += `&like[name]=${search}`
  }
  if(categoryId){
    url += `&equal[category_id]=${categoryId}`
  }

  let key="getResourceShopList_"+clientsId+"_"+is_online+"_"+id+"_"+sort+"_"+categoryId+"_"+search+"_"+scenesStageId+"_"+page+"_"+perPage;
  
  if(store.state.cacheList[key])return store.state.cacheList[key];
  let no_attributes=(sort==="template")?1:0;

  let data=request({
    url,
    method: 'get',
    params: {
      clients_id: clientsId,
      'equal[is_online]': is_online,
      'equal[id]': id,
      'equal[sort]': sort,
      'equal[scenes_stage_id]': scenesStageId,
      no_attributes,
      page,
      per_page: perPage
    }
  })
  console.log("datadatadatadatadatadata",data);

  store.state.cacheList[key]=data;
  return data;
}

// 获取资源详情
export function getResourceShopDetail ({
   id,
   clientsId,
   config_type
}) {
  return request({
    url: `api/courseware/shop-resources/${id}`,
    method: 'get',
    params: {
      clients_id: clientsId,
      config_type
    }
  })
}

/**
 * 资源分类管理
 */

// 新建资源分类
export function addResourceCategory ({
  clientsId,
  sort,
  parentId = 0,
  name
}) {
  return request({
    url: `api/courseware/resources-category?clients_id=${clientsId}`,
    method: 'post',
    data: {
      clientsId,
      sort,
      parent_id: parentId,
      name
    }
  })
}

// 删除资源分类
export function deleteResourceCategory ({ id, clientsId }) {
  return request({
    url: `api/courseware/resources-category/${id}`,
    method: 'delete',
    data: { clients_id: clientsId }
  })
}

// 修改资源分类
export function updateResourceCategory ({
  id,
  clientsId,
  sort,
  parentId = 0,
  name
}) {
  return request({
    url: `api/courseware/resources-category/${id}?clients_id=${clientsId}`,
    method: 'put',
    data: {
      clients_id: clientsId,
      sort,
      parent_id: parentId,
      name
    }
  })
}

// 获取资源分类树
export function getResourceCategoryTree ({
  clientsId,
  sort,
  ...params
}) {
  return request({
    url: 'api/courseware/resources-category/tree',
    method: 'get',
    params: {
      clients_id: clientsId,
      'equal[sort]': sort,
      ...params
    }
  })
}

/**
 * 资源分类管理 - 商城
 */

// 新建资源分类
export function addResourceCategoryShop ({
  clientsId,
  sort,
  parentId = 0,
  name
}) {
  return request({
    url: `api/courseware/shop-resources-category?clients_id=${clientsId}`,
    method: 'post',
    data: {
      clientsId,
      sort,
      parent_id: parentId,
      name
    }
  })
}

// 删除资源分类
export function deleteResourceCategoryShop ({ id, clientsId }) {
  return request({
    url: `api/courseware/shop-resources-category/${id}`,
    method: 'delete',
    data: { clients_id: clientsId }
  })
}

// 修改资源分类
export function updateResourceCategoryShop ({
  id,
  clientsId,
  sort,
  parentId = 0,
  name
}) {
  return request({
    url: `api/courseware/shop-resources-category/${id}?clients_id=${clientsId}`,
    method: 'put',
    data: {
      clients_id: clientsId,
      sort,
      parent_id: parentId,
      name
    }
  })
}

// 获取资源列表
export function getResourceListShop ({
  id,
  search,
  clientsId,
  categoryId,
  sort,
  is_online,
  scenesStageId,
  ...params
}) {
  let url = 'api/courseware/shop-resources?'
  if (search) {
    url += `&like[name]=${search}`
  }
  if(categoryId){
    url += `&equal[category_id]=${categoryId}`
  }
  return request({
    url,
    method: 'get',
    params: {
      clients_id: clientsId,
      'equal[is_online]': is_online,
      'equal[id]': id,
      'equal[scenes_stage_id]': scenesStageId,
      'equal[sort]': sort,
      ...params
    }
  })
}

// 获取资源分类树
export function getResourceCategoryShopTree ({
  clientsId,
  sort,
  ...params
}) {
  
  let key="getResourceCategoryShopTree_"+clientsId+"_"+sort;
  if(store.state.cacheList[key])return store.state.cacheList[key];

  let data = request({
    url: 'api/courseware/shop-resources-category/tree',
    method: 'get',
    params: {
      clients_id: clientsId,
      'equal[sort]': sort,
      ...params
    }
  })
  store.state.cacheList[key]=data;

  return data;
}

